export default __webpack_public_path__ + "static/media/tiger.3a9d9cfb.png";